<template>
  <v-card
    flat
    color="transparent"
  >
    <v-card-text class="msr--text pa-0 wrap body-1 ml-3">
      <v-layout column>
        <strong>{{ $t('userManagementYourAdmin') }}</strong>
        {{ $t('userManagementPleaseAskAdmin') }} {{ user.first_name }}
        {{ user.last_name }}
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UserManagement/UserManagementAdminHint.vue